// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.brokerage-page .dashboard-body {
  padding-bottom: 2rem;
}

.brokerage-hero__icon {
  flex-shrink: 0;
  width: 52px;
  height: 52px;
  border-radius: 12px;
  background: rgba(15, 118, 110, 0.4);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
}

.brokerage-section {
  background: #fff;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 12px;
  padding: 1rem;
  margin-bottom: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.brokerage-section__title {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.brokerage-section__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 0.85rem;
}

.brokerage-export-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.45rem 0.9rem;
  font-size: 0.86rem;
  font-weight: 600;
  font-family: inherit;
  color: #fff;
  background: linear-gradient(135deg, #15803d 0%, #22c55e 100%);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.brokerage-export-btn:hover:not(:disabled) {
  opacity: 0.95;
}

.brokerage-export-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.brokerage-export-toast {
  margin: 0 0 0.85rem;
  padding: 0.55rem 0.85rem;
  border-radius: 8px;
  font-size: 0.875rem;
}

.brokerage-export-toast--success {
  color: #166534;
  background: rgba(22, 101, 52, 0.1);
}

.brokerage-export-toast--error {
  color: #b91c1c;
  background: rgba(220, 38, 38, 0.08);
}

.brokerage-empty {
  text-align: center;
  color: #64748b;
  padding: 1.25rem 0.6rem;
}

.brokerage-empty i {
  display: block;
  font-size: 1.6rem;
  margin-bottom: 0.5rem;
}

.brokerage-table-wrap {
  overflow-x: auto;
}

.brokerage-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.85rem;
}

.brokerage-table th {
  padding: 0.75rem 0.8rem;
  text-align: left;
  font-size: 0.7rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #f8fafc;
  background: #0f172a;
  white-space: nowrap;
}

.brokerage-table td {
  padding: 0.75rem 0.8rem;
  border-bottom: 1px solid #e2e8f0;
  color: #1e293b;
  vertical-align: top;
}

.brokerage-table tbody tr:nth-child(even) {
  background: #fafafa;
}

.brokerage-btn-view {
  border: none;
  border-radius: 6px;
  padding: 0.35rem 0.7rem;
  font-size: 0.78rem;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  cursor: pointer;
}

.brokerage-currency-pills {
  display: inline-flex;
  gap: 0.3rem;
  flex-wrap: wrap;
}

.brokerage-currency-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.15rem 0.5rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 600;
  background: rgba(13, 148, 136, 0.12);
  color: #0f766e;
}

.brokerage-pagination {
  margin-top: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.brokerage-page-limit {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: #64748b;
}

.brokerage-page-limit select {
  min-width: 88px;
  padding: 0.4rem 0.6rem;
  font-size: 0.875rem;
  font-family: inherit;
  border: 1px solid #dbe2ea;
  border-radius: 8px;
  background: #fff;
  color: #0f172a;
  cursor: pointer;
}

.brokerage-page-limit select:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.brokerage-pagination__info {
  font-size: 0.85rem;
  color: #64748b;
}

.brokerage-pagination__nav {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.brokerage-pagination button {
  border: 1px solid #dbe2ea;
  background: #fff;
  color: #0f172a;
  border-radius: 8px;
  padding: 0.35rem 0.65rem;
  cursor: pointer;
}

.brokerage-pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.brokerage-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-bottom: 1rem;
}

.brokerage-stat-card {
  background: #fff;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 12px;
  padding: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.brokerage-stat-card__value {
  display: block;
  font-size: 1.4rem;
  font-weight: 700;
  color: #0f172a;
}

.brokerage-stat-card__label {
  font-size: 0.82rem;
  color: #64748b;
}

.brokerage-summary-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.6rem 1rem;
  margin-bottom: 1rem;
  font-size: 0.88rem;
}

.brokerage-level-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.brokerage-level-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 0.7rem;
  text-align: center;
}

.brokerage-level-card__lvl {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
}

.brokerage-level-card__amount {
  display: block;
  font-size: 1.05rem;
  font-weight: 700;
  color: #0f172a;
  margin-top: 0.25rem;
}

.brokerage-level-card__count {
  font-size: 0.74rem;
  color: #64748b;
}

.brokerage-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
  margin-bottom: 0.85rem;
}

.brokerage-toolbar select,
.brokerage-toolbar input {
  border: 1px solid #dbe2ea;
  border-radius: 8px;
  padding: 0.45rem 0.65rem;
  font-size: 0.86rem;
}

.brokerage-toolbar button {
  border: none;
  border-radius: 8px;
  padding: 0.45rem 0.85rem;
  font-size: 0.82rem;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  cursor: pointer;
}

.brokerage-back-btn {
  border: 1px solid #dbe2ea;
  background: #fff;
  color: #0f172a;
  border-radius: 8px;
  padding: 0.4rem 0.8rem;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}

.brokerage-level-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.6rem;
  padding: 0.1rem 0.45rem;
  border-radius: 999px;
  font-size: 0.74rem;
  font-weight: 700;
  background: rgba(15, 23, 42, 0.08);
  color: #0f172a;
}

@media (max-width: 1024px) {
  .brokerage-stats {
    grid-template-columns: 1fr 1fr;
  }
  .brokerage-level-grid {
    grid-template-columns: repeat(3, 1fr);
  }
  .brokerage-summary-grid {
    grid-template-columns: 1fr 1fr;
  }
}

@media (max-width: 768px) {
  .brokerage-stats,
  .brokerage-summary-grid {
    grid-template-columns: 1fr;
  }
  .brokerage-level-grid {
    grid-template-columns: 1fr 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/System/BrokerageManagementPage.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,6DAA6D;EAC7D,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,6DAA6D;EAC7D,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,qCAAqC;EACvC;EACA;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;EACA;IACE,8BAA8B;EAChC;AACF","sourcesContent":[".brokerage-page .dashboard-body {\n  padding-bottom: 2rem;\n}\n\n.brokerage-hero__icon {\n  flex-shrink: 0;\n  width: 52px;\n  height: 52px;\n  border-radius: 12px;\n  background: rgba(15, 118, 110, 0.4);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.3rem;\n}\n\n.brokerage-section {\n  background: #fff;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 12px;\n  padding: 1rem;\n  margin-bottom: 1rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.brokerage-section__title {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 700;\n  color: #0f172a;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.brokerage-section__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  margin-bottom: 0.85rem;\n}\n\n.brokerage-export-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  padding: 0.45rem 0.9rem;\n  font-size: 0.86rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: #fff;\n  background: linear-gradient(135deg, #15803d 0%, #22c55e 100%);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.brokerage-export-btn:hover:not(:disabled) {\n  opacity: 0.95;\n}\n\n.brokerage-export-btn:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.brokerage-export-toast {\n  margin: 0 0 0.85rem;\n  padding: 0.55rem 0.85rem;\n  border-radius: 8px;\n  font-size: 0.875rem;\n}\n\n.brokerage-export-toast--success {\n  color: #166534;\n  background: rgba(22, 101, 52, 0.1);\n}\n\n.brokerage-export-toast--error {\n  color: #b91c1c;\n  background: rgba(220, 38, 38, 0.08);\n}\n\n.brokerage-empty {\n  text-align: center;\n  color: #64748b;\n  padding: 1.25rem 0.6rem;\n}\n\n.brokerage-empty i {\n  display: block;\n  font-size: 1.6rem;\n  margin-bottom: 0.5rem;\n}\n\n.brokerage-table-wrap {\n  overflow-x: auto;\n}\n\n.brokerage-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.85rem;\n}\n\n.brokerage-table th {\n  padding: 0.75rem 0.8rem;\n  text-align: left;\n  font-size: 0.7rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #f8fafc;\n  background: #0f172a;\n  white-space: nowrap;\n}\n\n.brokerage-table td {\n  padding: 0.75rem 0.8rem;\n  border-bottom: 1px solid #e2e8f0;\n  color: #1e293b;\n  vertical-align: top;\n}\n\n.brokerage-table tbody tr:nth-child(even) {\n  background: #fafafa;\n}\n\n.brokerage-btn-view {\n  border: none;\n  border-radius: 6px;\n  padding: 0.35rem 0.7rem;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: #fff;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  cursor: pointer;\n}\n\n.brokerage-currency-pills {\n  display: inline-flex;\n  gap: 0.3rem;\n  flex-wrap: wrap;\n}\n\n.brokerage-currency-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  padding: 0.15rem 0.5rem;\n  border-radius: 999px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  background: rgba(13, 148, 136, 0.12);\n  color: #0f766e;\n}\n\n.brokerage-pagination {\n  margin-top: 0.8rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.brokerage-page-limit {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #64748b;\n}\n\n.brokerage-page-limit select {\n  min-width: 88px;\n  padding: 0.4rem 0.6rem;\n  font-size: 0.875rem;\n  font-family: inherit;\n  border: 1px solid #dbe2ea;\n  border-radius: 8px;\n  background: #fff;\n  color: #0f172a;\n  cursor: pointer;\n}\n\n.brokerage-page-limit select:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.brokerage-pagination__info {\n  font-size: 0.85rem;\n  color: #64748b;\n}\n\n.brokerage-pagination__nav {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.brokerage-pagination button {\n  border: 1px solid #dbe2ea;\n  background: #fff;\n  color: #0f172a;\n  border-radius: 8px;\n  padding: 0.35rem 0.65rem;\n  cursor: pointer;\n}\n\n.brokerage-pagination button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.brokerage-stats {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.brokerage-stat-card {\n  background: #fff;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 12px;\n  padding: 1rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.brokerage-stat-card__value {\n  display: block;\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.brokerage-stat-card__label {\n  font-size: 0.82rem;\n  color: #64748b;\n}\n\n.brokerage-summary-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.6rem 1rem;\n  margin-bottom: 1rem;\n  font-size: 0.88rem;\n}\n\n.brokerage-level-grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.brokerage-level-card {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 0.7rem;\n  text-align: center;\n}\n\n.brokerage-level-card__lvl {\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: #64748b;\n}\n\n.brokerage-level-card__amount {\n  display: block;\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin-top: 0.25rem;\n}\n\n.brokerage-level-card__count {\n  font-size: 0.74rem;\n  color: #64748b;\n}\n\n.brokerage-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  align-items: center;\n  margin-bottom: 0.85rem;\n}\n\n.brokerage-toolbar select,\n.brokerage-toolbar input {\n  border: 1px solid #dbe2ea;\n  border-radius: 8px;\n  padding: 0.45rem 0.65rem;\n  font-size: 0.86rem;\n}\n\n.brokerage-toolbar button {\n  border: none;\n  border-radius: 8px;\n  padding: 0.45rem 0.85rem;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: #fff;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  cursor: pointer;\n}\n\n.brokerage-back-btn {\n  border: 1px solid #dbe2ea;\n  background: #fff;\n  color: #0f172a;\n  border-radius: 8px;\n  padding: 0.4rem 0.8rem;\n  font-size: 0.82rem;\n  font-weight: 600;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.brokerage-level-pill {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.6rem;\n  padding: 0.1rem 0.45rem;\n  border-radius: 999px;\n  font-size: 0.74rem;\n  font-weight: 700;\n  background: rgba(15, 23, 42, 0.08);\n  color: #0f172a;\n}\n\n@media (max-width: 1024px) {\n  .brokerage-stats {\n    grid-template-columns: 1fr 1fr;\n  }\n  .brokerage-level-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  .brokerage-summary-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .brokerage-stats,\n  .brokerage-summary-grid {\n    grid-template-columns: 1fr;\n  }\n  .brokerage-level-grid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
